<template>
  <div class="view pa24">
    <table class="align-cen-table textc table table-hover table-bordered bgf6f9fa fixed-table text-ellipsis"
      v-if="accountMap && accountMap.state == 1">
      <thead>
        <tr>
          <th>{{ $t('miniprogram', 'miniProgramName') }}</th>
          <th>{{ $t('miniprogram', 'appId') }}</th>
          <th>{{ $t('miniprogram', 'authTime') }}</th>
        </tr>
      </thead>
      <tbody class="bgfff">
        <tr>
          <td>{{ accountMap.appName }}</td>
          <td>{{ accountMap.appId }}</td>
          <td>{{ accountMap.createTime | getDataTimeSec('yyyy-MM-dd hh:mm:ss') }}</td>
        </tr>
      </tbody>
    </table>
    <el-form v-else :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" class="demo-ruleForm">
      <el-form-item :label="$t('miniprogram', 'appName')" prop="appName">
        <el-col>
          <el-input :placeholder="$t('miniprogram', 'pleaseEnterMiniProgramName')" v-model="ruleForm.appName"></el-input>
          <p>
            {{ $t('miniprogram', 'miniProgramNameDesc') }}
          </p>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('miniprogram', 'appId')" prop="appId">
        <el-col>
          <el-input type="text" :placeholder="$t('miniprogram', 'pleaseEnterAppId')" v-model="ruleForm.appId"></el-input>
          <p>
            {{ $t('miniprogram', 'appIdDesc') }}
          </p>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('miniprogram', 'appSecret')" prop="appSecret">
        <el-col>
          <el-input :placeholder="$t('miniprogram', 'pleaseEnterAppSecret')" type="text" v-model="ruleForm.appSecret"></el-input>
          <p>
            {{ $t('miniprogram', 'appSecretDesc') }}
          </p>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-col>
          <el-button type="primary" @click="authorization">{{ $t('miniprogram', 'authorization') }}</el-button>
        </el-col>
      </el-form-item>
    </el-form>
    <div class="pl30 pt10">
      <p class="cA2 mb10">{{ $t('miniprogram', 'goToPersonalCenter') }}</p>
      <p class="mb10"><span class="corange ">*</span>{{ $t('miniprogram', 'userId') }}</p>
      <el-input :placeholder="$t('miniprogram', 'pleaseEnterUserId')" style="width:600px;margin-bottom:10px" type="text" v-model="userId"></el-input>
      <p class="corange mb10">{{ $t('miniprogram', 'confirmSharedCustomers') }}</p>
      <p class="cA2 mb10">{{ $t('miniprogram', 'transferDataDesc') }}</p>
      <el-button type="primary" @click="companyTransfer">{{ $t('miniprogram', 'confirmTransfer') }}</el-button>
      <el-button type="primary" @click="resetAuthorization">{{ $t('miniprogram', 'resetAuthorization') }}</el-button>
    </div>
  </div>
</template>

<script>
import { componentloginpage, companyTransfer } from "@/api/authorization"
import { componentCallBack } from '@/api/wechat'
import { getDataTimeSec } from "@/utils";
import { showLoading, hideLoading } from '@/utils/loading'
import i18nMixin from '@/mixins/i18nMixin'

export default {
  mixins: [i18nMixin],
  props: {
    accountMap: {
      default: {}
    }
  },
  data() {
    return {
      ruleForm: {
        appName: "",
        appId: "",
        appSecret: "",
      },
      rules: {
        appName: [
          { required: true, message: this.$t('miniprogram', 'pleaseEnterMiniProgramName'), trigger: "blur" },
        ],
        appId: [
          { required: true, message: this.$t('miniprogram', 'pleaseEnterAppId'), trigger: "blur" },
        ],
        appSecret: [
          { required: true, message: this.$t('miniprogram', 'pleaseEnterAppSecret'), trigger: "blur" },
        ],
      },
      userId: '',
    };
  },
  created() {
    console.log("accountMap", this.accountMap)
    if (this.$route.query.auth_code) {
      //oem授权回调
      let crmAppId = localStorage.getItem('crmAppId') || ''
      if (crmAppId) {
        showLoading();
        componentCallBack({ authCode: this.$route.query.auth_code, appId: crmAppId }).then(res => {
          localStorage.removeItem('crmAppId');
          this.getAppInfo();
          hideLoading();
          this.$message.success(this.$t('miniprogram', 'crmAuthSuccess'))
        })
          .catch(err => {
            console.log(err);
            hideLoading();
            this.$message.error(this.$t('miniprogram', 'crmAuthFailed'))
          });
      }
    }
  },
  filters: {
    getDataTimeSec(val) {
      return getDataTimeSec(val);
    },
  },
  methods: {
    authorization() {
      let data = {
        appName: this.ruleForm.appName,
        appId: this.ruleForm.appId,
        appSecret: this.ruleForm.appSecret,
        accountType: 2 //crm2
      }
      componentloginpage(data)
        .then(res => {
          localStorage.setItem('crmAppId', this.ruleForm.appId)
          window.open(res.data);
        })
    },
    getAppInfo() {
      this.$emit('getAppListInfo')
    },
    companyTransfer() {
      if (!this.userId) {
        this.$message({ type: "warning", message: this.$t('miniprogram', 'pleaseEnterUserId') });
        return;
      }
      this.$confirm(this.$t('miniprogram', 'confirmTransferCompany'), this.$t('miniprogram', 'tip'), {
        confirmButtonText: this.$t('miniprogram', 'confirm'),
        cancelButtonText: this.$t('miniprogram', 'cancel'),
        type: "info ",
      })
        .then(() => {
          companyTransfer({ userId: this.userId })
            .then(res => {
              console.log(res)
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: this.$t('miniprogram', 'transferSuccess'),
                });
              } else {
                this.$message({
                  message: this.$t('miniprogram', 'transferFailed') + "！" + res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.log(err)
              if (err.code == 200) {
                this.$message({
                  type: "success",
                  message: this.$t('miniprogram', 'transferSuccess'),
                });
              } else {
                this.$message({
                  message: this.$t('miniprogram', 'transferFailed') + "！" + err.message,
                  type: "error",
                });
              }
            })
        })
        .catch((err) => { });
    },
    resetAuthorization() {
      let accountId = ''
      if (this.accountMap.accountType == 2) {
        accountId = this.accountMap.accountId || 0
      }
      if (!accountId) {
        this.$message.error(this.$t('miniprogram', 'notAuthorized'))
        return
      }
      this.$emit('resetAuthorization', accountId)
    }
  }
};
</script>

<style lang="scss" scoped>
table th {
  background: #F7FAFA;
}

tbody:hover {
  background: #F7FAFA;
}

table tr {
  height: 50px;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fixed-table {
  table-layout: fixed;
}

.textc {
  text-align: center;
}

.bgf6f9fa {
  background: #F6F9FA;
}

.table-bordered {
  border: 1px solid #dee2e6;
}

.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;
}

body * {
  font-family: "Microsoft YaHei UI";
}

table {
  border-collapse: collapse;
}

* {
  outline: none;
}

*,
::after,
::before {
  box-sizing: border-box;
}

.el-input {
  width: 500px;
}
</style>
